import React, { useState, useContext } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { DonationContext } from "./DonationProvider";
import PropTypes from "prop-types";

const DonationForm = ({ defaultAmount = 0 }) => {
    const [name, setName] = useState("");
    const [amount, setAmount] = useState(defaultAmount.toString());
    const [submitting, setSubmitting] = useState(false);
    const { appId } = useContext(DonationContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        fetch(`${process.env.API_URL}/donations/${appId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name,
                amount: Number(amount),
            }),
        }).finally(() => {
            setSubmitting(false);
            setName("");
            setAmount(defaultAmount.toString());
        });
    };

    if (!appId) {
        throw new Error("DonationProvider component needed!");
    }

    return (
        <div className="ourpay-donation-form">
            <h2>Donation Form</h2>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Donor Name"
                    id="name-input"
                    required={true}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <TextField
                    label="Donation Amount"
                    id="amount-input"
                    required={true}
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />
                <Button type="submit" variant="contained" disabled={submitting}>
                    Donate
                </Button>
            </form>
        </div>
    );
};
DonationForm.propTypes = {
    defaultAmount: PropTypes.number,
};

export default DonationForm;
